// src/pages/Reports/ItemProfitLoss/components/exportItemProfitLossCsv.js
import dayjs from "dayjs";

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum = (val) => Number(val || 0).toFixed(2);
const fmtDate = (val) => (val ? dayjs(val).format("DD-MMM-YYYY") : "-");

/**
 * @param {object} params
 * @param {Array}  params.data     - from Redux state.itemProfitLoss.data
 * @param {object} params.totals   - from Redux state.itemProfitLoss.totals
 * @param {object} params.filters  - { type, fromDate, toDate, ... }
 * @param {string} params.title
 * @param {string} params.filename
 */
export const exportItemProfitLossCsv = ({
  data,
  totals,
  filters,
  title    = "Item Profit/Loss Report",
  filename = "item_profit_loss_report",
}) => {
  const rows = [
    [title],
    [`From: ${fmtDate(filters.fromDate)}  To: ${fmtDate(filters.toDate)}`],
    [],
  ];

  const headers = [
    "No.", "Item Name", "Group", "Category",
    "Sold Amount", "Costing Amount",
    "Return Sold", "Return Costing",
    "Profit",
  ].map(escape);

  rows.push(headers);

  data.forEach((row, i) => {
    rows.push([
      i + 1,
      row.item_name     || "",
      row.group_name    || "",
      row.category_name || "",
      fmtNum(row.sold_amount),
      fmtNum(row.costing_amount),
      fmtNum(row.return_sold_amount),
      fmtNum(row.return_costing_amount),
      fmtNum(row.item_profit),
    ].map(escape));
  });

  rows.push([]); // spacer
  rows.push([
    "Grand Total", "", "", "",
    fmtNum(totals.totalSold),
    fmtNum(totals.totalCosting),
    fmtNum(totals.totalReturnSold),
    fmtNum(totals.totalReturnCosting),
    fmtNum(totals.totalProfit),
  ].map(escape));

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};